const thoughts = [
  {
    id: 1,
    title: 'Debug your Confidence',
    date: 'Dec 2021',
    image: 'https://i.ibb.co/HzHn5Q5/imposter.png',
    description:
      'I just finished the fourth sprint of the Technigo Frontend Boot camp! I have succeeded in creating 16 different projects so far using a variety of techniques. When I take a well-earned second to think about how much I know now compared to before the Boot camp, I honestly find it quite mind-blowing.',
    link: 'https://medium.com/@kriss.stockhaus/debug-your-confidence-4927df4043f2',
  },
  {
    id: 2,
    title: 'Coding and Parenting Toddlers',
    date: 'Nov 2021',
    image: 'https://i.ibb.co/k4W232Q/toddlers.png',
    description:
      'To enter a coding boot camp and become a frontend developer in just six months is a huge challenge, add on raising two small children between 1–3 years old and the task can feel almost impossible at times. You can count on being constantly interu…',
    link: 'https://medium.com/@kriss.stockhaus/coding-and-parenting-toddlers-5242e39ed99c',
  },
];
export default thoughts;
